import React, { useContext, useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  formatedDate,
  fullName,
  getErrorString,
  isOwnerId,
} from "./../../constants/function";
import { Images } from "./../../assets/common";
import { SocketContext } from "./../../context/socket";
import { getUserId } from "./../../constants/function";
import NoData from "../Nodata";
import Loader from "./../../components/Loader";
import cookieStorage from "../../services/cookie-storage";
import ApiService from "./../../services/api-service";
import BlockConfirmPopup from "../BlockConfirmPopup";
import notifier from "../Notifier";
import { useTranslation } from "react-i18next";
export default function Message(props) {
  const { t } = useTranslation("common");
  const token = cookieStorage.getCookie("Authorization");
  const socket = useContext(SocketContext).Socket;
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = React.useState(false);
  const [roomId, setRoomId] = useState(props["roomId"]);
  const history = useHistory();
  const [pageNo, setPageNo] = useState(1);
  const [loaded, setLoaded] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [user, setUser] = useState({});
  useEffect(() => {
    return () => {
      setMessages([]);
      if (props["close"]) {
        props.close();
      }
    };
  }, []);
  useEffect(() => {
    setLoading(true);
    if (!props["type"]) {
      if (socket)
        socket.emit("join", { JWT: token, roomId: props["playListId"] });
    }

    if (socket) {
      socket.on("connect_error", function (err) {
        setLoading(false);
        console.log("Socket connection failed", err);
        setError(t("noData.message6"));
      });
    }
  }, [socket, props["senderUserId"]]);
  useEffect(() => {
    if (socket) {
      socket.on("roomData", roomDataListener);
      // socket.on("directRoomdata", directRoomdata);
      socket.on("received", messageListener);
      socket.on("message_received", message_received);
      socket.on("blocked", function (data) {
        const msgs = messages;
        const curentUser = getUserId();
        if (
          (data.userId === curentUser && data.roomId === roomId) ||
          data.userId === curentUser
        ) {
          setMessages((prevMessages) => {
            const newMessages = [...prevMessages];
            const msg = newMessages.map((m) => ({
              ...m,
              isBlocked:
                m?.user?._id === data.userId && data.status === "blocked",
            }));

            return msg;
          });
          // const msg = msgs.map((m) => ({
          //   ...m,
          //   isBlocked: m?.user?._id === data.userId && data.status === "blocked",
          // }));
          // setMessages([...msg]);
        }
      });
    }
  }, [socket]);
  useEffect(() => {
    if (props["type"] === "direct" && props["roomId"]) {
      setMessages([]);
      setPageNo(1);
      getPrivateMessage(
        { pageNo: 1, pageSize: 10, roomId: props["roomId"] },
        []
      );
    } else if (props["type"] && props["type"] === "group") {
      setMessages([]);
      setPageNo(1);
      getPlaylistMessage(
        {
          pageNo: 1,
          pageSize: 10,
          roomId: props["playListId"],
          // livestreamMessage: props["isStream"] ? true : false,
        },
        []
      );
    }
  }, [props["roomId"]]);
  const handleBlocked = (data) => {
    const msgs = messages;
    const curentUser = getUserId();
    if (data.userId === curentUser && data.roomId === roomId) {
      const msg = msgs.map((m) => ({
        ...m,
        isBlocked:
          m?.user?._id === data._id
            ? data.status === "blocked"
              ? true
              : false
            : m.isBlocked,
      }));
      setMessages([...msg]);
    }
  };
  const getPrivateMessage = async (param, data) => {
    setError(t("noData.message7"));
    setLoading(true);
    // readMessage(param["roomId"], getUserId());
    try {
      const response = await ApiService.GET_PRIVATE_MESSAGE(param);
      const roomData = response["result"];
      if (
        roomData &&
        roomData.length > 0 &&
        props["type"] === "direct" &&
        roomData[0]["roomId"] === props["roomId"]
        // && props['senderUserId'] === roomData[0]['senderUserId']
      ) {
        if (param.pageNo > 1) {
          setLoaded(roomData.length < 10 ? true : false);
          const data = [...messages];
          data.unshift(...roomData);
          setMessages([...data]);

          var body = {
            JWT: token,
            roomId: props["roomId"],
            senderUserId: getUserId(),
          };
          socket.emit("read-message-dm", body);
          let objDiv = document.getElementById(
            roomData[roomData.length - 1]._id
          );
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollIntoView();
          }
          setLoading(false);
        } else {
          setMessages([...roomData]);
          setLoaded(roomData.length === 0 ? true : false);
          var body = {
            JWT: token,
            roomId: props["roomId"],
            senderUserId: getUserId(),
          };
          socket.emit("read-message-dm", body);
          let objDiv = document.getElementById("chat_div");
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollTop = objDiv.scrollHeight;
          }
          setLoading(false);
        }
      } else {
        if (param.pageNo > 1) {
          setLoaded(true);
        } else setMessages([]);
      }
      setError(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getPlaylistMessage = async (param, data) => {
    setError(t("noData.message7"));
    if (!param.livestreamMessage) delete param.livestreamMessage;
    setLoading(true);
    // readMessage(param["roomId"], getUserId());
    try {
      const response = await ApiService.GET_PLAYLIST_MESSAGE(param);
      const roomData = response["result"];
      if (
        roomData &&
        roomData.length > 0 &&
        props["type"] === "group" &&
        roomData[0]["roomId"] === props["roomId"]
        // && props['senderUserId'] === roomData[0]['senderUserId']
      ) {
        if (param.pageNo > 1) {
          setLoaded(roomData.length < 10 ? true : false);
          const data = [...messages];
          data.unshift(...roomData);
          setMessages([...data]);
          let objDiv = document.getElementById(
            roomData[roomData.length - 1]._id
          );
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollIntoView();
          }
          setLoading(false);
        } else {
          setMessages([...roomData]);
          setLoaded(roomData.length === 0 ? true : false);

          let objDiv = document.getElementById("chat_div");
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollTop = objDiv.scrollHeight;
          }
        }
        setLoading(false);
      } else {
        if (param.pageNo > 1) {
          setLoaded(true);
        } else setMessages([]);
        setLoading(false);
      }
      setError(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const readMessage = async (roomId, userId) => {
    try {
      const response = await ApiService.READ_MESSAGE({
        roomId: roomId,
        senderUserId: userId,
      });
    } catch (error) {
      console.log(getErrorString(error));
    }
  };
  const roomDataListener = (roomData) => {
    if (
      roomData &&
      roomData.length > 0 &&
      messages.length === 0 &&
      props["playListId"] === roomData[0]["roomId"]
    ) {
      if (!props["type"]) {
        setMessages([...messages, ...roomData]);
        let objDiv = document.getElementById("chat_div");
        if (objDiv) {
          // objDiv.style.scrollBehavior = "smooth";
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }
    }
    setError(null);
    setLoading(false);
  };
  const directRoomdata = (roomData) => {
    if (
      roomData &&
      roomData.length > 0 &&
      messages.length === 0 &&
      props["type"] === "direct" &&
      roomData[0]["roomId"] === props["roomId"]
      // && props['senderUserId'] === roomData[0]['senderUserId']
    ) {
      setMessages([...messages, ...roomData]);
      let objDiv = document.getElementById("chat_div");
      if (objDiv) {
        // objDiv.style.scrollBehavior = "smooth";
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    }
    setError(null);
    setLoading(false);
  };

  const messageListener = (message) => {
    if (
      (props["playListId"] === message["roomId"] &&
        message["senderUserId"] !== getUserId()) ||
      (props["playListId"] === message["roomId"] &&
        message["senderUserId"] === getUserId() &&
        message["type"])
    ) {
      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        newMessages.push(message);
        return newMessages;
      });
      let objDiv = document.getElementById("chat_div");
      setTimeout(() => {
        let newELement = document.getElementById(message["_id"]);
        if (objDiv) {
          objDiv.style.scrollBehavior = "smooth";
          objDiv.scrollTop = objDiv.scrollTop + newELement.scrollHeight + 10;
        }
      }, 0);
    }
  };
  const message_received = (message) => {
    if (
      props["type"] === "direct" &&
      message["roomId"] === props["roomId"]
      // && message['senderUserId'] === props['senderUserId']
    ) {
      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        newMessages.push(message);
        return newMessages;
      });
      let objDiv = document.getElementById("chat_div");
      setTimeout(() => {
        let newELement = document.getElementById(message["_id"]);
        if (objDiv) {
          objDiv.style.scrollBehavior = "smooth";
          objDiv.scrollTop = objDiv.scrollTop + newELement.scrollHeight + 10;
        }
      }, 0);
    }
  };
  useEffect(() => {
    if (props["newMessage"] && props["newMessage"]["message"]) {
      // console.log(props["newMessage"]);
      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        newMessages.push(props["newMessage"]);
        return newMessages;
      });
      let objDiv = document.getElementById("chat_div");
      setTimeout(() => {
        let newELement = document.getElementById(props["newMessage"]["_id"]);
        if (objDiv) {
          objDiv.style.scrollBehavior = "smooth";
          objDiv.scrollTop = objDiv.scrollTop + newELement.scrollHeight + 10;
        }
      }, 0);
      // messageListener(props["newMessage"]);
    }
  }, [props["newMessage"]]);
  const handleScroll = (target) => {
    if (target) {
      var a = target.scrollTop;
      console.log(`top:${a}`);
      var b = target.scrollHeight - target.clientHeight;
      if (a < 100 && !loading && !loaded) {
        // run a function called doSomething
        const next = pageNo + 1;
        setPageNo(next);
        if (props["type"] === "direct" && props["roomId"])
          getPrivateMessage(
            { pageNo: next, pageSize: 10, roomId: props["roomId"] },
            messages
          );
        else {
          getPlaylistMessage(
            {
              pageNo: next,
              pageSize: 10,
              roomId: props["playListId"],
              // livestreamMessage: props["isStream"] ? true : false,
            },
            []
          );
        }
      }
    }
  };
  const handleClose = () => {
    setOpenBlock(false);
  };
  const handleBlock = async (data, status) => {
    try {
      setOpenBlock(false);
      setUser(null);
      // setLoading(true);
      const payload = {
        userId: data._id,
        status: status,
      };
      const response = await ApiService.BLOCK_USER_CHAT(payload);
      const msg = messages.map((m) => ({
        ...m,
        isBlocked:
          m?.user?._id === data._id
            ? status === "blocked"
              ? true
              : false
            : m.isBlocked,
      }));

      setMessages([...msg]);
      // setLoading(false);
      socket.emit("block", {
        userId: data._id,
        status: status,
        roomId: roomId,
      });
      const user = getUserId();
      notifier.success(
        `User ${status === "blocked" ? "Blocked" : "Unblocked"}`
      );
      if (props["type"] === "direct") props.onChangeStatus(status);
      console.log(messages);
    } catch (error) {
      // setLoading(false);
    }
  };
  const handleOpen = (index, nft) => {
    if (messages[index].isOpened) {
      if (messages[index].gift === "musicNFT")
        history.push(`/app/MyNft/${nft["nftId"]}`);
      else history.push(`/app/PlaylistNftDetail/${nft["nftId"]}`);
    } else {
      const msg = messages;
      msg[index]["isOpened"] = true;
      const img = msg[index].nft.thumnailImg.filePath;
      msg[index].nft.thumnailImg.filePath = Images.gift_open;
      setMessages([...msg]);
      setTimeout(() => {
        msg[index].nft.thumnailImg.filePath = img;
        setMessages([...msg]);
        notifier.success(t("notifier.success.toast12"));
        updateGiftStatus(msg[index]["gift"], messages[index]["assetId"]);
      }, 3000);
    }
  };
  const updateGiftStatus = async (type, assetId) => {
    try {
      const response = await ApiService.updatGiftStatus({
        type: type,
        assetId: assetId,
      });
    } catch (error) {}
  };
  return (
    <Box
      id="chat_div"
      className={
        "__chat_messages" +
        (props["isStream"] ? " _streaming_chat_messages" : "")
      }
      onScroll={(event) => handleScroll(event.target)}
    >
      {messages.length > 0 ? (
        messages.map((msg, index) => (
          <Stack
            id={msg["_id"]}
            key={msg["_id"]}
            direction={!isOwnerId(msg["user"]["_id"]) ? "row" : "row-reverse"}
            alignItems="end"
            spacing={1}
            sx={{ width: "100%" }}
            className="mt-10"
          >
            {msg?.isBlocked ? (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "#FFEE20",
                }}
              ></div>
            ) : (
              <img
                style={{ width: "28px", height: "28px", borderRadius: "50%" }}
                src={
                  msg["user"] && msg["user"]["profileImg"]["filePath"]
                    ? msg["user"]["profileImg"]["filePath"]
                    : Images.dummy
                }
                alt="user"
              />
            )}

            <Stack sx={{ width: "auto", flexDirection: "column" }}>
              {msg["gift"] ? (
                <Box sx={{ background: "#2C2C2C", borderRadius: "24px" }}>
                  {!isOwnerId(msg["user"]["_id"]) ? (
                    <img
                      onClick={() => handleOpen(index, msg["nft"])}
                      className="_cp"
                      style={{ borderRadius: "24px", width: "100%" }}
                      src={
                        !msg.isOpened
                          ? Images.gift_closed
                          : msg?.nft?.thumnailImg?.filePath
                      }
                      alt=""
                    />
                  ) : null}
                  <Typography
                    sx={{
                      wordBreak: "break-all !important",
                      marginLeft: !isOwnerId(msg["user"]["_id"])
                        ? "unset !important"
                        : "auto !important",
                      textAlign: "justify",
                      color: "#FFEE20",
                      fontSize: "16px",
                    }}
                    className={
                      "fs-13" +
                      (isOwnerId(msg["user"]["_id"])
                        ? " _chat_from"
                        : " _chat_to") +
                      (msg?.isBlocked ? " _line_through" : "") +
                      (props["isStream"] ? " _stream_msg" : "")
                    }
                    dangerouslySetInnerHTML={{
                      __html: isOwnerId(msg["user"]["_id"])
                        ? `You gifted NFT: "${msg?.nft?.title}"`
                        : msg["message"],
                    }}
                  ></Typography>
                </Box>
              ) : (
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    marginLeft: !isOwnerId(msg["user"]["_id"])
                      ? "unset !important"
                      : "auto !important",
                    textAlign: "justify",
                    color:
                      msg["type"] && msg["type"] === "tip"
                        ? "#FFEE20"
                        : "#ffffff",
                  }}
                  className={
                    "fs-13" +
                    (isOwnerId(msg["user"]["_id"])
                      ? " _chat_from"
                      : " _chat_to") +
                    (msg?.isBlocked ? " _line_through" : "") +
                    (props["isStream"] ? " _stream_msg" : "")
                  }
                  dangerouslySetInnerHTML={{ __html: msg["message"] }}
                ></Typography>
              )}

              <Stack
                direction={
                  !isOwnerId(msg["user"]["_id"]) ? "row" : "row-reverse"
                }
                alignItems="baseline"
                gap="10px"
              >
                <Typography
                  onClick={
                    () => {
                      props["type"] === "direct"
                        ? isOwnerId(msg["user"]["_id"])
                          ? setOpenBlock(false)
                          : setOpenBlock(true)
                        : isOwnerId(msg?.playlistDetails[0]?.createdBy) &&
                          !isOwnerId(msg["user"]["_id"])
                        ? setOpenBlock(true)
                        : setOpenBlock(false);
                      setUser(msg);
                    }
                    // history.push(`/app/ArtistProfile/${msg["user"]["_id"]}`)
                  }
                  className={
                    "fs-11 _cp" + (msg?.isBlocked ? " _line_through" : "")
                  }
                  sx={{
                    color: isOwnerId(msg["user"]["_id"])
                      ? "#FFEE20"
                      : "#00C3FD",
                  }}
                >
                  {isOwnerId(msg["user"]["_id"]) ? "Me" : fullName(msg["user"])}
                </Typography>
                <Typography
                  className={
                    "fs-11-5 " +
                    (isOwnerId(msg["user"]["_id"]) ? " mr_auto" : " ml_auto")
                  }
                  sx={{ color: "#707070" }}
                >
                  {formatedDate(msg["createdAt"], null, null, true)}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        ))
      ) : props.isStream ? null : (
        <NoData lable={error ? error : t("noData.noData")} />
      )}
      {loading ? <Loader wait={true} _class="__loader_inside" /> : null}
      {openBlock ? (
        <BlockConfirmPopup
          user={user}
          open={openBlock}
          handleClose={handleClose}
          onHandleBlock={handleBlock}
          type={props["type"]}
        />
      ) : null}
    </Box>
  );
}
